import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  AssignmentRounded,
  ManageAccountsRounded,
  Assistant,
  ChecklistRounded,
  RuleRounded,
  StorageRounded,
  LockRounded,
  Summarize,
} from '@mui/icons-material';
import CustomSubMenu from '../CustomSubMenu';
import { useNavigate } from 'react-router-dom';
import { MenuItem } from 'react-pro-sidebar';

const ManagementSubMenu = ({
  location,
  collapsed,
}: {
  location: any;
  collapsed: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <CustomSubMenu
      props={{
        location,
        collapsed,
        label: 'Management',
        icon: <AssignmentRounded />,
        items: [
          <MenuItem
            icon={<ManageAccountsRounded />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/user-management`, '_blank');
              } else {
                navigate('/admin/user-management');
              }
            }}
          >
            User Management
          </MenuItem>,
          <MenuItem
            icon={<Assistant />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/status-management`, '_blank');
              } else {
                navigate('/admin/status-management');
              }
            }}
          >
            Status Management
          </MenuItem>,
          <MenuItem
            icon={<ChecklistRounded />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/check-management`, '_blank');
              } else {
                navigate('/admin/check-management');
              }
            }}
          >
            Check Management
          </MenuItem>,
          <MenuItem
            icon={<RuleRounded />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/required-fields`, '_blank');
              } else {
                navigate('/admin/required-fields');
              }
            }}
          >
            Required Fields
          </MenuItem>,
          <MenuItem
            icon={<StorageRounded />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/database`, '_blank');
              } else {
                navigate('/admin/database');
              }
            }}
          >
            Database
          </MenuItem>,
          <MenuItem
            icon={<LockRounded />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/lock-management`, '_blank');
              } else {
                navigate('/admin/lock-management');
              }
            }}
          >
            Lock Management
          </MenuItem>,
          <MenuItem
            icon={<Summarize />}
            onClick={(event: any) => {
              if (event.metaKey || event.ctrlKey) {
                window.open(`/admin/activity-groups`, '_blank');
              } else {
                navigate('/admin/activity-groups');
              }
            }}
          >
            Activity Groups
          </MenuItem>,
        ],
        popperItems: [
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/user-management`, '_blank');
                } else {
                  navigate('/admin/user-management');
                }
              }}
            >
              <ListItemIcon>
                <ManageAccountsRounded />
              </ListItemIcon>
              <ListItemText primary="User Management" />
            </ListItemButton>
          </ListItem>,
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/status-management`, '_blank');
                } else {
                  navigate('/admin/status-management');
                }
              }}
            >
              <ListItemIcon>
                <Assistant />
              </ListItemIcon>
              <ListItemText primary="Status Management" />
            </ListItemButton>
          </ListItem>,
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/check-management`, '_blank');
                } else {
                  navigate('/admin/check-management');
                }
              }}
            >
              <ListItemIcon>
                <ChecklistRounded />
              </ListItemIcon>
              <ListItemText primary="Check Management" />
            </ListItemButton>
          </ListItem>,
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/database`, '_blank');
                } else {
                  navigate('/admin/database');
                }
              }}
            >
              <ListItemIcon>
                <StorageRounded />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
          </ListItem>,
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/lock-management`, '_blank');
                } else {
                  navigate('/admin/lock-management');
                }
              }}
            >
              <ListItemIcon>
                <LockRounded />
              </ListItemIcon>
              <ListItemText primary="Lock Management" />
            </ListItemButton>
          </ListItem>,
          <ListItem disablePadding>
            <ListItemButton
              onClick={(event: any) => {
                if (event.metaKey || event.ctrlKey) {
                  window.open(`/admin/activity-groups`, '_blank');
                } else {
                  navigate('/admin/activity-groups');
                }
              }}
            >
              <ListItemIcon>
                <Summarize />
              </ListItemIcon>
              <ListItemText primary="Activity Groups" />
            </ListItemButton>
          </ListItem>,
        ],
      }}
    />
  );
};

export default ManagementSubMenu;
